import React, { useCallback } from "react";
import { useTranslations } from "@src/packages/i18n";
import { useBasicInfo } from "../BasicInfoContext";
import {
  BasicInfoQuestionLayout,
  DiagnosisStatusOptions,
  type DiagnosisStatus,
} from "../components";
import { useNavigation } from "@react-navigation/native";

export function VaricoceleScreen() {
  const t = useTranslations();
  const { state, updateState, next } = useBasicInfo("Varicocele");
  const navigation = useNavigation();

  const selection: DiagnosisStatus | null =
    state.hadVaricoceles === "yes_diagnosed"
      ? "diagnosed"
      : state.hadVaricoceles === "yes_undiagnosed"
        ? "suspected"
        : state.hadVaricoceles === "no"
          ? "no"
          : null;

  const handleSelection = useCallback(
    (val: DiagnosisStatus) => {
      const hadVaricoceles: "yes_diagnosed" | "yes_undiagnosed" | "no" | null =
        val === "diagnosed"
          ? "yes_diagnosed"
          : val === "suspected"
            ? "yes_undiagnosed"
            : val === "no"
              ? "no"
              : null;
      const stateUpdates = { hadVaricoceles };

      if (selection === null) {
        next(stateUpdates);
        return;
      }

      updateState(stateUpdates);
    },
    [next, selection, updateState],
  );

  return (
    <BasicInfoQuestionLayout
      route="Varicocele"
      title={t("med_history.basic_info.varicocele.title")}
      helpText={t("med_history.basic_info.help.varicocele")}
      onBack={() => navigation.goBack()}
      onSave={() => next()}
      saveDisabled={selection === null}
      hideSaveButton={selection === null}
      saveLabel={t("med_history.shared.next")}
    >
      <DiagnosisStatusOptions
        diagnosedLabel={t("med_history.shared.yes_diagnosed")}
        noLabel={t("med_history.shared.no")}
        onChange={handleSelection}
        suspectedLabel={t("med_history.shared.maybe_undiagnosed")}
        value={selection}
      />
    </BasicInfoQuestionLayout>
  );
}

export default VaricoceleScreen;
